import { isBrowser } from 'config/environment'

export enum FULLSTORY_CUSTOM_EVENT {
  SAVED_FILTER_CREATED = 'Saved Filter Created',
  FILTER_ADDED = 'Filter Added',
  FILTER_GROUP_ADDED = 'Filter Group Added',
  FILTER_TOGGLED = 'Filter Toggled',
  FILTERS_APPLIED = 'Filters Applied'
}

export const fsTrackEvent = (
  eventName: FULLSTORY_CUSTOM_EVENT,
  properties?: { [key: string]: string | number }
) => {
  if (isBrowser && window.FS?.event) {
    window.FS.event(`PROSPECTOR - ${eventName}`, properties || {})
  }
}
